import { selectChatThreads } from '../Chats/chatSlice'
import useTranslation from 'hooks/useTranslation'
import { useSelector } from 'react-redux'
import ChatList from '../Chats/ChatList'

const Notifications = () => {
  const threads = useSelector(selectChatThreads)
  const { active, inactive } = Object.values(threads).reduce((r, e) => {
    if (e.closed_at) r.inactive += 1
    else r.active += 1
    return r
  }, { active: 0, inactive: 0 })

  const { t } = useTranslation('help')

  return (
    <div className='help__notification chat'>
      {active > 0 && <>
        <h4>{t('activeReports')}</h4>
        <ChatList showOnlyActiveChats />
      </>}

      {inactive > 0 && <>
        <h4>{t('archivedReports')}</h4>
        <ChatList showOnlyInactiveChats />
      </>}
    </div>
  )
}

export default Notifications